/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isEventTarget as n, on as t } from "./events.js";
import { makeHandle as o } from "./handleUtils.js";
import { removeMaybe as e } from "./maybe.js";
import { watchTracked as r } from "./accessorSupport/watch.js";
export { autorun } from "./accessorSupport/trackingUtils.js";

function i(n, t) {
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return c(n, t, o, l);
}

function u(n, t) {
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return c(n, t, o, s);
}

function c(n, t) {
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var i = arguments.length > 3 ? arguments[3] : undefined;
  var u = null;
  var c = o.once ? function (n, o) {
    i(n) && (e(u), t(n, o));
  } : function (n, o) {
    i(n) && t(n, o);
  };

  if (u = r(n, c, o.sync, o.equals), o.initial) {
    var _t = n();

    c(_t, _t);
  }

  return u;
}

function l(n) {
  return !0;
}

function s(n) {
  return !!n;
}

function f(i, u, c) {
  var l = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var s = null,
      f = null,
      m = null;

  function a() {
    s && f && (f.remove(), null == l.onListenerRemove || l.onListenerRemove(s), s = null, f = null);
  }

  function p(n) {
    l.once && l.once && e(m), c(n);
  }

  var d = r(i, function (o, e) {
    a(), n(o) && (s = o, f = t(o, u, p), null == l.onListenerAdd || l.onListenerAdd(o));
  }, l.sync);
  return m = o(function () {
    d.remove(), a();
  }), m;
}

var m = {
  sync: !0
},
    a = {
  initial: !0
},
    p = {
  sync: !0,
  initial: !0
};
export { a as initial, i as react, f as reactListener, u as reactTruthy, m as sync, p as syncAndInitial };